import {
  hideSentimentFunc,
  renderValidation,
  sentimentNumber,
} from '../../render-helper';

export default function (params: any) {
  const { hideSentimentRating } = params;
  return [
    {
      render: 'content',
      header: 'Reviews_Original',
    },
    {
      render: 'content_to_zh',
      header: 'Reviews_Chinese',
    },
    {
      render: 'content_to_en',
      header: 'Reviews_English',
    },
    {
      render: 'sentiment_rating',
      header: 'Sentiment',
      renderHelper: [hideSentimentRating ? hideSentimentFunc : sentimentNumber],
    },
    {
      header: 'Validation',
      render: 'isvalid',
      width: 10,
      renderHelper: [renderValidation],
    },
    {
      render: 'reviewer',
      header: 'Reviewers',
    },
    {
      render: 'comment_time',
      header: 'Time',
    },
    {
      render: 'tweets_like',
      header: 'Like',
      numFmt: ['0'],
    },
    {
      render: 'engagement',
      header: 'Engagement',
      numFmt: ['0'],
    },
    {
      render: 'content_url',
      header: 'URL',
    },
  ];
}
